import { Component, OnInit, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { GeoService } from 'src/app/services/geo.service';
import { AuthService } from 'src/app/services/auth.service';
import { UserRole } from 'src/app/models/security/user-role-enum';

@Component({
  selector: 'app-header',
  standalone: true,
  templateUrl: './header.component.html',
  imports: [CommonModule, RouterLink]
})
export class HeaderComponent implements OnInit {
  @Input() isLogin = false;
  @Input() userRol: string | null = null;

  roles = UserRole;
  authService = inject(AuthService);
  geoService = inject(GeoService);

  userFullName: string | null = null;

  countryCode: string | null = null;
  countryName: string | null = null;

  ngOnInit(): void {
    this.userFullName = this.authService.getUserName();

    this.geoService.getLocation().subscribe({
      next: (res) => {
        this.countryCode = res?.country_code?.toLowerCase(); // ej: "do"
        this.countryName = res?.country_name; // ej: "Dominican Republic"
      },
      error: () => {
        this.countryCode = null;
        this.countryName = 'Desconocido';
      }
    });
  }

  toggleMenu(): void {
    document.getElementById('app-main')?.classList.toggle('open-menu');
  }

  doLogout() {
    this.authService.logout();
  }
}
